const minuteInMs = 60 * 1000
const hourInMs = 60 * minuteInMs
const dayInMs = 24 * hourInMs

/**
 * @class CONST
 */
module.exports = {
  // needs a string prefix to ease gql parsing
  appointmentAgeRanges: {
    '0-10': 'age_0to10',
    '11-17': 'age_11to17',
    '18-34': 'age_18to34',
    '35-45': 'age_35to45',
    '46-59': 'age_46to59',
    '60+': 'age_60'
  },

  appointmentStatus: {
    CANCELED: 'canceled',
    COMPLETED: 'completed',
    NOT_SHOW: 'notShow',
    SCHEDULED: 'scheduled'
  },

  appointmentType: {
    PHONE: 'phone',
    SHOP: 'shop',
    WEB: 'web'
  },

  authStrategy: {
    JWT: 'jwt',
    LOCAL: 'local',
    NONE: 'none',
    OKTA: 'okta'
  },

  // 15 minutes - must be a clean partition of an hour and an appointment
  commonAppointmentDenominator: 900000,

  cronJobs: {
    HUB_IMPORT_STORES: 'stores'
  },

  cronTaskStatuses: {
    COMPLETE: 'complete',
    ERROR: 'error',
    PENDING: 'pending',
    PROCESSING: 'processing'
  },

  dayInMs,

  dayOfWeek: {
    FRIDAY: 'friday',
    MONDAY: 'monday',
    SATURDAY: 'saturday',
    SUNDAY: 'sunday',
    THURSDAY: 'thursday',
    TUESDAY: 'tuesday',
    WEDNESDAY: 'wednesday'
  },

  dayOfWeekByKey: {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday'
  },

  entityType: {
    SERVICE: 'service',
    SHOP: 'shop'
  },

  environment: {
    CI: 'ci',
    DEV: 'dev',
    PRODUCTION: 'production',
    UAT: 'uat'
  },

  errors: {
    appointment: {
      canceled: 'appointment.canceled',
      noAvailability: 'appointment.noAvailability',
      notFound: 'appointment.notFound',
      startAfterEnd: 'appointment.beforeAfterEnd'
    },
    auth: {
      invalidToken: 'auth.invalidToken',
      missingEmail: 'auth.missingEmail',
      tokenExpired: 'auth.tokenExpired'
    },
    availability: {
      invalidRange: 'availability.invalidRange'
    },
    exceptionalEvent: {
      mismatchUuid: 'exceptionalEvent.mismatchUuid',
      notFound: 'exceptionalEvent.notFound',
      startAfterEnd: 'appointment.beforeAfterEnd'
    },
    hub: {
      invalidShopEzId: 'hub.invalidShopEzId',
      invalidShopIds: 'hub.invalidShopIds',
      shopAlreadyDeleted: 'hub.shopAlreadyDeleted'
    },
    service: {
      alreadyExists: 'service.alreadyExists',
      conflictingOpenings: 'service.conflictingOpenings',
      invalidColor: 'service.invalidColor',
      invalidDuration: 'service.invalidDuration',
      invalidIcon: 'service.invalidIcon',
      invalidName: 'service.invalidName',
      invalidOpeningDuration: 'service.invalidOpeningDuration',
      invalidOpeningTime: 'service.invalidOpeningTime',
      invalidParallelAppointment: 'service.invalidParallelAppointment',
      invalidPrice: 'service.invalidPrice',
      missingSetupService: 'service.missingSetupService',
      missingUuid: 'service.missingUuid',
      mustResetOpenings: 'service.mustResetOpenings',
      notEnabled: 'service.notEnabled',
      notFound: 'service.notFound'
    },
    shop: {
      alreadySelected: 'shop.alreadySelected',
      conflictingOpenings: 'shop.conflictingOpenings',
      invalidMaxParallelAppointments: 'shop.invalidMaxParallelAppointments',
      missingUuid: 'shop.missingUuid',
      noServiceSelected: 'shop.noServiceSelected',
      notEnabled: 'shop.notEnabled',
      notFound: 'shop.notFound'
    },
    user: {
      alreadyExists: 'user.alreadyExists',
      badOldPassword: 'user.badOldPassword',
      notFound: 'user.notFound'
    }
  },

  eventType: {
    CLOSING: 'closing',
    OPENING: 'opening'
  },

  hourInMs,

  hub: {
    // to prevent multi language
    countryCodeMapping: {
      'cs-cz': 'cze-CZ',
      'de-at': 'dut-AT',
      'de-ch': 'fre-CH',
      'de-de': 'ger-DE',
      'en-gb': 'eng-GB',
      'en-ie': 'eng-IE',
      'es-es': 'spa-ES',
      'fr-be': 'fre-BE',
      'fr-ch': 'fre-CH',
      'fr-fr': 'fre-FR',
      'hu-hu': 'hun-HU',
      'it-ch': 'fre-CH',
      'it-it': 'ita-IT',
      'nl-be': 'fre-BE',
      'nl-nl': 'dut-NL',
      'pl-pl': 'pol-PL',
      'pt-pt': 'por-PT',
      'ro-ro': 'rum-RO',
      'sk-sk': 'slk-SK'
    },

    defaultLanguage: 'eng-GB',

    languageMapping: {
      at: 'dut-AT',
      be: 'fre-BE',
      ch: 'fre-CH',
      cz: 'cze-CZ',
      de: 'ger-DE',
      en: 'eng-GB',
      es: 'spa-ES',
      fr: 'fre-FR',
      hu: 'hun-HU',
      ie: 'eng-IE',
      it: 'ita-IT',
      nl: 'dut-NL',
      pl: 'pol-PL',
      pt: 'por-PT',
      ro: 'rum-RO',
      sk: 'slk-SK'
    }
  },

  // language key : ISO631-1
  languageFallback: { locale: 'en', url: 'en', veeValidate: 'en', vuetify: 'en' },
  languages: [
    { country: 'CZ', language: 'cs', locale: 'cs', url: 'cs', veeValidate: 'cs', vuetify: 'cs' },
    { country: 'CZ', language: 'cs', locale: 'cs-CZ', url: 'cs-CZ', veeValidate: 'cs', vuetify: 'cs' },
    //
    { country: 'DE', language: 'de', locale: 'de', url: 'de', veeValidate: 'de', vuetify: 'de' },
    { country: 'AT', language: 'de', locale: 'de-AT', url: 'de-AT', veeValidate: 'de', vuetify: 'de' },
    { country: 'CH', language: 'de', locale: 'de-CH', url: 'de-CH', veeValidate: 'de', vuetify: 'de' },
    { country: 'DE', language: 'de', locale: 'de-DE', url: 'de-DE', veeValidate: 'de', vuetify: 'de' },
    //
    { country: 'GB', language: 'en', locale: 'en', url: 'en', veeValidate: 'en', vuetify: 'en' },
    { country: 'GB', language: 'en', locale: 'en-GB', url: 'en-GB', veeValidate: 'en', vuetify: 'en' },
    { country: 'IE', language: 'en', locale: 'en-IE', url: 'en-IE', veeValidate: 'en', vuetify: 'en' },
    //
    { country: 'ES', language: 'es', locale: 'es', url: 'es', veeValidate: 'es', vuetify: 'es' },
    { country: 'ES', language: 'es', locale: 'es-ES', url: 'es-ES', veeValidate: 'es', vuetify: 'es' },
    //
    { country: 'FR', language: 'fr', locale: 'fr', url: 'fr', veeValidate: 'fr', vuetify: 'fr' },
    { country: 'BE', language: 'fr', locale: 'fr-BE', url: 'fr-BE', veeValidate: 'fr', vuetify: 'fr' },
    { country: 'CH', language: 'fr', locale: 'fr-CH', url: 'fr-CH', veeValidate: 'fr', vuetify: 'fr' },
    //
    { country: 'HU', language: 'hu', locale: 'hu', url: 'hu', veeValidate: 'hu', vuetify: 'hu' },
    { country: 'HU', language: 'hu', locale: 'hu-HU', url: 'hu-HU', veeValidate: 'hu', vuetify: 'hu' },
    //
    { country: 'IT', language: 'it', locale: 'it', url: 'it', veeValidate: 'it', vuetify: 'it' },
    { country: 'IT', language: 'it', locale: 'it-IT', url: 'it-IT', veeValidate: 'it', vuetify: 'it' },
    { country: 'CH', language: 'it', locale: 'it-CH', url: 'it-CH', veeValidate: 'it', vuetify: 'it' },
    //
    { country: 'NL', language: 'nl', locale: 'nl', url: 'nl', veeValidate: 'nl', vuetify: 'nl' },
    { country: 'BE', language: 'nl', locale: 'nl-BE', url: 'nl-BE', veeValidate: 'nl', vuetify: 'nl' },
    { country: 'NL', language: 'nl', locale: 'nl-NL', url: 'nl-NL', veeValidate: 'nl', vuetify: 'nl' },
    //
    { country: 'PL', language: 'pl', locale: 'pl', url: 'pl', veeValidate: 'pl', vuetify: 'pl' },
    { country: 'PL', language: 'pl', locale: 'pl-PL', url: 'pl-PL', veeValidate: 'pl', vuetify: 'pl' },
    //
    { country: 'PT', language: 'pt', locale: 'pt', url: 'pt', veeValidate: 'pt_PT', vuetify: 'pt' },
    { country: 'PT', language: 'pt', locale: 'pt-PT', url: 'pt-PT', veeValidate: 'pt_PT', vuetify: 'pt' },
    //
    { country: 'RO', language: 'ro', locale: 'ro', url: 'ro', veeValidate: 'ro', vuetify: 'ro' },
    { country: 'RO', language: 'ro', locale: 'ro-RO', url: 'ro-RO', veeValidate: 'ro', vuetify: 'ro' },
    //
    { country: 'SK', language: 'sk', locale: 'sk', url: 'sk', veeValidate: 'sk', vuetify: 'sk' },
    { country: 'SK', language: 'sk', locale: 'sk-SK', url: 'sk-SK', veeValidate: 'sk', vuetify: 'sk' }
  ],

  minuteInMs,

  notificationType: {
    NEW_APPOINTMENT: 'newAppointment',
    UPDATE_APPOINTMENT: 'updateAppointment'
  },

  origins: {
    ESSILOR: 'essilor',
    IFRAME: 'iframe',
    LANDING: 'landing',
    OTHERS: 'others',
    TRANSITIONS: 'transitions'
  },

  personaType: {
    FOR_ME: 'forMe',
    FOR_MY_CHILD: 'forMyChild',
    FOR_SOMEONE_I_KNOW: 'forSomeoneIKnow'
  },

  queryHardLimit: 1000,

  serviceType: {
    COLOR_BLINDNESS: 'colorBlindness',
    CONTACT_LENS: 'contactLens',
    CONTACT_LENS_EXAM: 'contactLensExam',
    CONTACT_LENS_PURCHASE: 'contactLensPurchase',
    CORNEAL_TOPOGRAPHY: 'cornealTopography',
    CUSTOM: 'custom',
    DRIVING_TEST: 'drivingTest',
    DRY_EYE: 'dryEye',
    EYE_FATIGUE: 'eyeFatigue',
    EYE_TEST: 'eyeTest',
    FRAME_PURCHASE: 'framePurchase',
    FRAME_REPAIR: 'frameRepair',
    GLASSES_COLLECTION: 'glassesCollection',
    GLAUCOMA: 'glaucoma',
    HEARING_TEST: 'hearingTest',
    KID_EYE_TEST: 'kidEyeTest',
    LENS_TYPE: 'lensType',
    LOW_VISION: 'lowVision',
    NHS_EYE_TEST: 'NHSEyeTest',
    OCT_EYE_TEST: 'OCTEyeTest',
    OCULAR_TONOMETRY: 'ocularTonometry',
    OPHTALMOLOGY: 'ophtalmology',
    ORTHOKERATOLOGY: 'orthokeratology',
    PRODUCTS: 'products'
  },

  serviceTypeValues: [
    { color: '#58C7EA', icon: 'mdi-circle-multiple', key: 'CONTACT_LENS', value: 'contactLens' }, // @deprecated - kept for enum compatbility
    { color: '#178AE9', icon: 'mdi-circle-multiple', key: 'CONTACT_LENS_EXAM', value: 'contactLensExam' },
    {
      color: '#F2965B',
      icon: 'mdi-file-table-box-multiple-outline',
      key: 'CONTACT_LENS_PURCHASE',
      value: 'contactLensPurchase'
    },
    { color: '#FED437', icon: 'mdi-palette', key: 'COLOR_BLINDNESS', value: 'colorBlindness' },
    { color: '#918313', icon: 'mdi-bullseye', key: 'CORNEAL_TOPOGRAPHY', value: 'cornealTopography' },
    { icon: 'mdi-circle-multiple', key: 'CUSTOM', value: 'custom' },
    { color: '#5A6675', icon: 'mdi-car-hatchback', key: 'DRIVING_TEST', value: 'drivingTest' },
    { color: '#0086D6', icon: 'mdi-eyedropper', key: 'DRY_EYE', value: 'dryEye' },
    { color: '#0D52A0', icon: 'mdi-flash-red-eye', key: 'EYE_FATIGUE', value: 'eyeFatigue' },
    { color: '#223344', icon: 'mdi-eye', key: 'EYE_TEST', value: 'eyeTest' },
    { color: '#F49655', icon: 'mdi-glasses', key: 'FRAME_PURCHASE', value: 'framePurchase' },
    { color: '#FFD618', icon: 'mdi-screwdriver', key: 'FRAME_REPAIR', value: 'frameRepair' },
    { color: '#0086D6', icon: 'mdi-cart-arrow-right', key: 'GLASSES_COLLECTION', value: 'glassesCollection' },
    { color: '#6557C4', icon: 'mdi-eye-settings', key: 'GLAUCOMA', value: 'glaucoma' },
    { color: '#5E6A71', icon: 'mdi-ear-hearing', key: 'HEARING_TEST', value: 'hearingTest' },
    { color: '#FC5E6E', icon: 'mdi-account-child-outline', key: 'KID_EYE_TEST', value: 'kidEyeTest' },
    { color: '#5EBEB3', icon: 'mdi-comment-eye', key: 'LENS_TYPE', value: 'lensType' },
    { color: '#D5EAFB', icon: 'mdi-eye-off', key: 'LOW_VISION', value: 'lowVision' },
    { color: '#D5EAFB', icon: 'mdi-account-check', key: 'NHS_EYE_TEST', value: 'NHSEyeTest' },
    { color: '#4682b4', icon: 'mdi-monitor-eye', key: 'OCT_EYE_TEST', value: 'OCTEyeTest' },
    {
      color: '#DE6B12',
      icon: 'mdi-image-filter-center-focus-strong',
      key: 'OCULAR_TONOMETRY',
      value: 'ocularTonometry'
    },
    { color: '#62BEB3', icon: 'mdi-eye-check-outline', key: 'OPHTALMOLOGY', value: 'ophtalmology' },
    { color: '#DEC712', icon: 'mdi-eye-circle', key: 'ORTHOKERATOLOGY', value: 'orthokeratology' },
    { color: '#7296E8', icon: 'mdi-cart', key: 'PRODUCTS', value: 'products' }
  ],

  serviceUsers: {
    hub: true
  },

  siteData: {
    essilor: {
      countries: {
        AT: {
          defaultLanguage: 'de-DE',
          googleAnalyticsId: 'GTM-MTBVPX6',
          name: 'Austria'
        },
        BE: {
          availableLanguages: ['fr', 'nl'],
          defaultLanguage: 'fr-BE',
          googleAnalyticsId: 'GTM-TZ3GDQM',
          name: 'Belgium'
        },
        CH: {
          availableLanguages: ['de', 'fr', 'it'],
          defaultLanguage: 'fr-CH',
          googleAnalyticsId: 'GTM-PL5DJKQ',
          name: 'Switzerland'
        },
        CZ: {
          defaultLanguage: 'cs-CZ',
          googleAnalyticsId: 'GTM-T3VMNJK',
          name: 'Czech Republic'
        },
        DE: {
          defaultLanguage: 'de-DE',
          googleAnalyticsId: 'GTM-MRC5K7J',
          name: 'Germany'
        },
        ES: {
          defaultLanguage: 'es-ES',
          googleAnalyticsId: 'GTM-WVND7R3',
          name: 'Spain'
        },
        FR: {
          defaultLanguage: 'fr-FR',
          googleAnalyticsId: 'GTM-PFFPH5J',
          name: 'France'
        },
        GB: {
          defaultLanguage: 'en-GB',
          googleAnalyticsId: 'GTM-PB44534',
          name: 'United Kingdom'
        },
        HU: {
          defaultLanguage: 'hu-HU',
          googleAnalyticsId: 'GTM-53ZDRJF',
          name: 'Hungary'
        },
        IE: {
          defaultLanguage: 'en-IE',
          googleAnalyticsId: 'GTM-KCTL6JZ',
          name: 'Ireland'
        },
        IT: {
          defaultLanguage: 'it-IT',
          googleAnalyticsId: 'GTM-56TGTRN',
          name: 'Italy'
        },
        NL: {
          defaultLanguage: 'nl-NL',
          googleAnalyticsId: 'GTM-NBH9RSH',
          name: 'Netherlands'
        },
        PL: {
          defaultLanguage: 'pl-PL',
          googleAnalyticsId: 'GTM-TT8HQ8Z',
          name: 'Poland'
        },
        PT: {
          defaultLanguage: 'pt-PT',
          googleAnalyticsId: 'GTM-547NMDM',
          name: 'Portugal'
        },
        RO: {
          defaultLanguage: 'ro-RO',
          googleAnalyticsId: 'GTM-56MM3WL',
          name: 'Romania'
        },
        SK: {
          defaultLanguage: 'sk-SK',
          googleAnalyticsId: 'GTM-5CXBBNQ',
          name: 'Slovakia'
        }
      }
    },
    galileo: {
      countries: {
        IT: {
          defaultLanguage: 'it-IT',
          googleAnalyticsId: 'GTM-K7WGL3J',
          name: 'Italy'
        }
      }
    },
    nikon: {
      countries: {
        FR: {} // fake entry to avoid crashing
      }
    },
    'nikon-it': {
      countries: {
        IT: {
          defaultLanguage: 'it-IT',
          googleAnalyticsId: 'GTM-KZBZJJD',
          name: 'Italy'
        }
      }
    }
  },

  sites: {
    essilor: 'essilor',
    galileo: 'galileo',
    nikon: 'nikon',
    'nikon-it': 'nikon-it'
  },

  userRoles: {
    ADMIN: 'admin',
    ANONYMOUS: 'anonymous',
    COUNTRY_MANAGER: 'countryManager',
    DELETED: 'deleted',
    OWNER: 'owner'
  }
}
